var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui red basic label",class:[
        (_vm.pointing) ? _vm.pointing + ' pointing' : '',
        (_vm.is_required) ? '': ' orange'
    ]},[_vm._v("\n    "+_vm._s((_vm.is_required) ? '必填': '有則填寫')+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }